import { Injectable, signal } from '@angular/core';

export interface AiPageCase {
  caseId: number;
  caseReference: string;
}

/**
 * The case the current page is about. Pages showing one case call set() once it is loaded and
 * clear() in ngOnDestroy; the "Ask Crystal AI" bar adapts its placeholder and links a NEW chat to it.
 */
@Injectable({ providedIn: 'root' })
export class AiPageContextService {
  readonly current = signal<AiPageCase | null>(null);
  set(caseId: number, caseReference: string): void { this.current.set({ caseId, caseReference }); }
  clear(): void { this.current.set(null); }
}
